<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-row class="bradcrumb">
            <router-link :to="{ name: 'role-links' }" class="root">
                Dashboard
            </router-link>
            <span class="child">/ Question Bank </span>
        </v-row>
        <br />
        <v-container>
            <v-card outlined>
                <v-card-title class="heading">
                    <span class="headline">{{ formTitle }}</span>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-card-text>
                    <div class="my-2">
                        <center>
                            <v-col cols="12" sm="6" md="4">
                                <v-autocomplete
                                    dense
                                    v-model="editedItem.course"
                                    :items="course_list"
                                    item-text="course"
                                    item-value="id"
                                    label="Select Subject"
                                    persistent-hint
                                    :disabled="editedIndex != -1"
                                    :filled="editedIndex == -1 ? false : true"
                                    return-object
                                    single-line
                                ></v-autocomplete>
                            </v-col>
                        </center>
                        <center>
                            <v-col cols="12" sm="6" md="4">
                                <v-autocomplete dense v-model="qttypeselect" :items="examtype" item-text="exam" item-value="id" label="Select Exam"></v-autocomplete>
                            </v-col>
                        </center>
                    </div>
                    <div class="my-2">
                        <center>
                            <v-btn @click="questionbankentry" class="ma-2 button4">Question Bank Entry</v-btn>
                            <v-btn @click="studentquestionview(editedItem.course, qttypeselect)" class="ma-2 button2">Student Question View</v-btn>
                            <v-btn @click="downloadquestionbank" class="ma-2 button4">Download Question Bank</v-btn>
                        </center>
                    </div>
                </v-card-text>
            </v-card>
        </v-container>
        <div>
            <v-card v-if="qlist.length != 0">
                <v-card-title>
                    Question Bank
                    <v-spacer></v-spacer>
                    <template>
                        <!-- <download-excel
              :data="qlist"
              :fields="table_fields_2"
              worksheet="Question Bank"
              name="Question_bank.xls"
            > -->
                        <v-btn class="button" @click="downloadExel()"><v-icon left dark>mdi-plus</v-icon>Excel File</v-btn>
                        <!-- </download-excel> -->
                    </template>
                </v-card-title>

                <v-simple-table fixed-header height="700px" id="questiontTable" class="mytable">
                    <thead>
                        <tr>
                            <th>Sr. No.</th>
                            <th>Unit</th>
                            <th>Question Statement</th>

                            <th colspan="6"><center>Options</center></th>
                            <!-- <th>Correct Answer</th> -->
                        </tr>
                        <tr>
                            <th colspan="3"></th>
                            <th v-for="opt in option_header" :key="opt">{{opt}}</th>

                            <th colspan="3">Correct Answer</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in qlist" :key="item">
                            <td>{{ item.qno }}</td>
                            <td>{{ item.unit }}</td>
                            <td>
                                <span v-if="item.question != 'null'" v-html="item.question"></span>
                                <span v-if="item.question_image != 'null'">
                                    <img class="imgs-question" :src="item.question_image" @click="zooimg(item.question_image)" />
                                </span>
                            </td>
                            <td v-for="opt in item.options" :key="opt.id">
                                <span class="ml-2" v-html="opt.option_value"></span>
                            </td>
                            <td>-</td>
                            <td>{{item.correct_opt}}</td>
                        </tr>
                    </tbody>
                </v-simple-table>

                <!-- <v-simple-table fixed-header
               height="700px"> 
                        <template v-slot:default>
                        <thead>
                        <tr>
                            <th>Sr.No.</th>
                            <th>Unit</th>
                            <th>Statement</th>
                            <th>Options</th>
                           
                        </tr>
                        </thead>
                       
                      
                        <tbody>
                            <tr v-for="(item) in qlist" :key="item">
                            <td>
                             {{item.qno}}
                             
                             
                            </td>     
                            <td>
                             {{item.unit}}
                            </td>     
                            <td>
                             
                               <span
                                v-if="item.question != 'null'"
                                v-html="item.question"
                                ></span>
                              <span v-if="item.question_image != 'null'">
                                                        <img
                                                            class="imgs-question"
                                                            :src="item.question_image"
                                                            @click="zooimg(item.question_image)"
                                                        />
                                                        </span>
                            </td>     
                            <td>
                                 <div v-for="opt in item.options" :key="opt.id">
                                     <div class="row">
                                        <span class="opt-label" >{{opt.option_name}}</span>
                                        
                                         <span class="ml-2" v-html="opt.option_value">

                                         </span>
                                     </div>
                                 </div>
                               
                            </td>     
                           
                            </tr>
                        </tbody>
                        </template>    
                   </v-simple-table> -->
            </v-card>
        </div>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data: () => ({
            search: "",
            allquestionbankdata: [],
            qlist: [],
            overlay: false,
            snackbar_msg: "",
            snackbar: false,
            color: "",
            iseditable: false,
            load: false,
            dialog: false,
            course_list: null,
            selected_course: "",
            qttypeselect: "",
            examtype: null,
            examResultDetails: "",
            option_header: ["A", "B", "C", "D", "E"],
            //crs_list: null,
            table_fields_2: {
                "Question No": "qno",
                Unit: "unit",
                Question: "question",
                Options: "options_excel",
            },

            headers: [
                { text: "Sr.No", value: "qno" },
                { text: "Unit", value: "unit" },
                { text: "Statement", value: "question" },
            ],

            errorMsg: {
                course: false,
            },

            editedIndex: -1,
            editedItem: {
                id: 0,
                course: "",
            },
            defaultItem: {
                id: 0,
                course: "",
            },
        }),

        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "Question Bank" : "";
            },
        },

        watch: {
            dialog(val) {
                val || this.close();
            },
            overlay(val) {
                val = () => {
                    this.overlay = false;
                };
            },
        },
        mounted() {
            axios
                .post("/Qbank/viewCourse")
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.course_list = res.data.course_list;
                        this.examtype = res.data.examtype_list;
                        this.qttypeselect = res.data.exams_current_id;
                        this.load = true;
                    } else {
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    window.console.log(error);
                });
        },
        methods: {
            initializeErrorMsgFalse() {
                this.errorMsg.course = false;
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            addQuestionBank(item, item1) {
                this.$router.push({
                    name: "add-que-Bank",
                    params: { examtype_id: item1, courseId: item },
                });
            },
            downloadquestionbank() {
                this.allquestionbankdata = [];
                if (this.editedItem.course == "") {
                    this.showSnackbar("#b71c1c", "Please Select Course!!!");
                    return;
                }

                let data = {
                    crsid: this.editedItem.course.id,
                };

                axios
                    .post("/Qbank/viewCourseQuestion", data)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.qlist = res.data.question_list;
                            // console.log(this.qlist)

                            // for(var j=0;j<this.qlist.length;j++){
                            //                 this.exam_data=[]
                            //                  this.exam_data[this.qlist[j].qno1] =this.qlist[j].qno
                            //                  this.exam_data[this.qlist[j].unit1] =this.qlist[j].unit
                            //                 this.exam_data[this.qlist[j].question1] =this.qlist[j].question

                            //                 console.log(this.qlist[j].qno)
                            //                   console.log(this.qlist[j].unit)
                            //                 console.log(this.qlist[j].question)
                            //                 for(var k=0;k<this.qlist[j].options.length;k++){
                            //                   console.log(this.qlist[j].options[k].option_value)
                            //                     this.exam_data[this.qlist[j].options[k].option_name]=this.qlist[j].options[k].option_value
                            //                 }
                            //                 this.allquestionbankdata.push(this.exam_data)
                            //             }

                            this.load = true;
                        } else {
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        window.console.log(error);
                    });
            },
            questionbankentry() {
                if (this.editedItem.course == "") {
                    this.showSnackbar("#b71c1c", "Please Select Course!!!");
                    return;
                }
                if (this.qttypeselect == "") {
                    this.showSnackbar("#b71c1c", "Please Select Exam!!!");
                    return;
                }
                this.$store.commit("setcourseid", this.editedItem.course.id);
                this.$store.commit("setqbankquestype", this.qttypeselect);
                // console.log('setqbankquestype',this.qttypeselect)
                //this.$router.push("/add-question-Bank")
                this.$router.push("/papersetter/questionBankTemplate");
            },
            studentquestionview(item, item1) {
                if (this.editedItem.course == "") {
                    this.showSnackbar("#b71c1c", "Please Select Course!!!");
                    return;
                }
                if (this.qttypeselect == "") {
                    this.showSnackbar("#b71c1c", "Please Select Exam!!!");
                    return;
                }
                this.$router.push({
                    name: "stud-que-view",
                    params: {
                        examtype_id: item1,
                        courseId: item,
                        questypeid: this.qttypeselect,
                    },
                });
            },
            downloadExel() {
                var htmltable = document.getElementById("questiontTable");
                var html = htmltable.outerHTML;
                window.open("data:application/vnd.ms-excel," + encodeURIComponent(html));
            },

            isValidated() {
                if (this.editedItem.course) {
                    return true;
                } else {
                    if (!this.editedItem.course) {
                        this.errorMsg.course = true;
                    }

                    return false;
                }
            }, // .....end of isValidated()
        },
    };
</script>
<style scoped>
    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }

    .v-icon-size {
        font-size: 20px;
    }

    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }

    .edit-avatar:hover {
        background-color: #b0bec5;
    }

    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }

    .edit-v-icon:hover {
        color: white;
    }
    .mytable /deep/ thead th {
        color: rgb(0, 0, 0) !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        /* text-align: center; */
    }
</style>
